/* Routing */
import {Link, useParams} from "react-router-dom";
/* Contexts */
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
/* Helpers */
import { toggleDetailsView } from "../../../helper/toggleMenuView";
import { sortSections } from "../../../helper/tools";
/* Components */
import {
    deleteEstimateSection,
    getEstimateSectionList,
    updateSectionStatus
} from "../../../api/admin/estimateReq";
import {useEffect, useState} from "react";
import FormSectionCreate from "../../../forms/admin/FormSectionCreate";
import FormSectionUpdate from "../../../forms/admin/FormSectionUpdate";

export default function DevisList() {

    const {
        estimateSectionList, setEstimateSectionList,
        setEstimateSelectedSection
    } = useData();
    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();
    const [ thisSection, setThisSection ] = useState();
    const [ showCreateModal, setShowCreateModal ] = useState(false);
    const [ showUpdateModal, setShowUpdateModal ] = useState(false);

    const apiEstimateSectionList = async () => {
        const response = await getEstimateSectionList(token)
            setEstimateSectionList(response)
            setEstimateSelectedSection(estimateSectionList.filter(section => section?.section === id)[0])
    }

    useEffect(() => {
        apiEstimateSectionList()
    }, [ id ]);

    const handleAddSection = (e) => {
        setShowCreateModal(true)
    }

    const handleEditSectionMain = (sectionId) => {
        setThisSection(sectionId)
        setShowUpdateModal(true)
    }

    const handleDeleteSection = (e, section) => {
        e.preventDefault()
        let sectionNum = section?.section
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement une section.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette section?. Les lignes de devis associées seront également supprimées.")) {
                const body = {
                    "section_num": sectionNum,
                }
                deleteEstimateSection(token, body)
            }
        }
    }

    const handleSectionsOrder = () => {
        window.location.href = `/admin/documents/devis/sections/order`
    }

    const handleChangeEstimateSectionEnabled = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une section.");
        } else {
            const sectionId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "sectionId": sectionId,
                    "sectionEnabled": false,
                }
                alert("Vous venez de désactiver cette section.");
                await updateSectionStatus(token, body);
                await apiEstimateSectionList();
            } else {
                let body = {
                    "sectionId": sectionId,
                    "sectionEnabled": true,
                }
                alert("Vous venez d'activer cette section.");
                await updateSectionStatus(token, body);
                await apiEstimateSectionList();
            }
        }
    };

    return (
        <>
            { showCreateModal &&
                <div id="0" className="modal modal-create">
                    <FormSectionCreate setShowModalCreate={setShowCreateModal} legend="Création d'une section"/>
                </div>
            }
            { showUpdateModal &&
                <div className="modal modal-update">
                    <FormSectionUpdate setShowUpdateModal={setShowUpdateModal} section={thisSection} legend="Modification d'une section"/>
                </div>
            }
            <div className="details devis active">
                <div className="double-legend">
                    <legend>
                        <button className="add-button" onClick={handleAddSection}>
                            <i className="fa fa-plus"></i>
                            <span>Ajouter une section</span>
                        </button>
                    </legend>
                    <legend>
                        <button className="order-button" onClick={handleSectionsOrder}>
                            <i className="fa fa-sort"></i>
                            <span>Changer l'ordre des sections</span>
                        </button>
                    </legend>
                </div>
                <div className="details-content double">
                    <div className="section-list">
                        {sortSections(estimateSectionList)?.map((section, index) => (
                            <p key={index}>
                                <Link to={`/admin/documents/devis/section/${section?.section}/voir`}>
                                    <span>{section?.section}</span>
                                    <span>{section?.description?.length > 60 ? section?.description.substring(0, 60) + "..." : section?.description}</span>
                                </Link>
                                <div>
                                    <i className="fa fa-pen-to-square" onClick={() => handleEditSectionMain(section?.id)}>
                                    </i>
                                    <i
                                        id={section?.id}
                                        className={section?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleChangeEstimateSectionEnabled}
                                        title={section?.enabled ? "Section visible - Cliquer pour masquer" : "Section masquée - Cliquer pour rendre visible"}
                                    />
                                    <i className="fa fa-trash" onClick={(e) => handleDeleteSection(e, section)}></i>
                                </div>
                            </p>
                        ))}
                    </div>
                </div>
                <div className="arrow" onClick={ toggleDetailsView }>
                    <span><i className="fa fa-chevron-left"></i></span>
                </div>
            </div>
        </>
    )
}
